module.exports = __webpack_public_path__ + "static/img/sup_logo_4.ad1ffc32.png";